import React, { useEffect, useState } from "react";
import { adminApi } from "../api/adminApi";
import { adminTheme } from "styles/adminTheme.js"
import "../styles/admin-theme.css"
import RoleChip from "components/RoleChip";
import StatusBadge from "components/StatusBadge";
import { IconButton } from "@material-ui/core";
import { Edit, Delete } from "@material-ui/icons";

import {
    Card,
    CardHeader,
    CardContent,
    Typography,
    TextField,
    Button,
    List,
    ListItem,
    ListItemText,
    Divider,
    CircularProgress,
    makeStyles,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";



const useStyles = makeStyles((theme) => ({
    card: {
        background: "#0f172a",
        color: "#e2e8f0",
    },
    headerRoot: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    actions: {
        display: "flex",
        gap: theme.spacing(1),
    },
    tableHead: {
        backgroundColor: "#020617",
    },
    tableHeadCell: {
        color: "#94a3b8",
        fontWeight: 600,
        fontSize: 12,
        textTransform: "uppercase",
    },
    roleChip: {
        marginRight: theme.spacing(0.5),
        marginBottom: theme.spacing(0.5),
    },
    statusChipActive: {
        backgroundColor: "#22c55e22",
        color: "#0891b2",
    },
    statusChipInactive: {
        backgroundColor: "#ef444422",
        color: "#0891b2",
    },
    emptyState: {
        padding: theme.spacing(3),
        textAlign: "center",
        color: "#94a3b8",
    },
    loadingWrapper: {
        padding: theme.spacing(3),
        display: "flex",
        justifyContent: "center",
    },
    buttonPrimary: {
        background: "#3b82f6",
        color: "white",
        padding: "10px 16px",
        border: "none",
        borderRadius: 6,
        cursor: "pointer"
    },

    buttonSmall: {
        background: "#64748b",
        color: "white",
        padding: "6px 12px",
        border: "none",
        borderRadius: 6,
        cursor: "pointer",
        marginRight: 6
    },

    buttonDanger: {
        background: "#dc2626",
        color: "white",
        padding: "6px 12px",
        border: "none",
        borderRadius: 6,
        cursor: "pointer",
        marginLeft: 6
    },

    buttonWarning: {
        background: "#f59e0b",
        color: "white",
        padding: "6px 12px",
        border: "none",
        borderRadius: 6,
        cursor: "pointer",
        marginLeft: 6
    },

    buttonSuccess: {
        background: "#16a34a",
        color: "white",
        padding: "6px 12px",
        border: "none",
        borderRadius: 6,
        cursor: "pointer",
        marginLeft: 6
    },
}));

export default function AdminRolesPage() {
    const classes = useStyles();
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [name, setName] = useState("");
    const [description, setDescription] = useState("");

    const loadRoles = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await adminApi.getRoles();
            setRoles(data);
        } catch (err) {
            console.error(err);
            setError("Rollen konnten nicht geladen werden.");
        } finally {
            setLoading(false);
        }
    };
    const [editingRole, setEditingRole] = useState(null);
    const handleEdit = (role) => {
        setEditingRole(role);
        setName(role.name);
        setDescription(role.description || "");
    };
    const handleSave = async () => {
        if (!name.trim()) return;

        try {
            if (editingRole) {
                await adminApi.updateRole(editingRole.id, {
                    name: name.trim(),
                    description,
                });
            } else {
                await adminApi.createRole({
                    name: name.trim(),
                    description,
                });
            }

            setEditingRole(null);
            setName("");
            setDescription("");
            await loadRoles();
        } catch (err) {
            console.error(err);
            alert("Fehler beim Speichern der Rolle.");
        }
    };

    const formRef = React.useRef(null);

    useEffect(() => {
        if (!editingRole) return;

        const onKeyDown = (e) => {
            const insideForm = formRef.current?.contains(document.activeElement);
            if (e.key === "Escape" && insideForm) {
                e.preventDefault();
                cancelEdit();
            }
        };

        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [editingRole]);

    useEffect(() => {
        loadRoles();
    }, []);

    const handleCreate = async () => {
        if (!name.trim()) return;

        try {
            await adminApi.createRole({ name: name.trim(), description });
            setName("");
            setDescription("");
            await loadRoles();
        } catch (err) {
            console.error(err);
            alert("Fehler beim Anlegen der Rolle.");
        }
    };
    const handleDelete = async (role) => {
        const confirmed = window.confirm(
            `Möchtest du die Rolle "${role.name}" wirklich löschen?`
        );

        if (!confirmed) return;

        try {
            await adminApi.deleteRole(role.id);
            await loadRoles();
        } catch (err) {
            console.error(err);
            alert("Rolle konnte nicht gelöscht werden.");
        }
    };
    const cancelEdit = () => {
        setEditingRole(null);
        setName("");
        setDescription("");
    };
    return (
        <Card className={classes.card}>
            {/* HEADER */}
            <CardHeader
                classes={{ root: classes.headerRoot }}
                title={
                    <Typography variant="h5" style={{ color: "#60a5fa" }}>
                        Rollenverwaltung
                    </Typography>
                }
                subheader={
                    <Typography variant="body2" style={{ color: "#94a3b8" }}>
                        Definiere Rollen, die später Benutzern zugewiesen werden können.
                    </Typography>
                }
                action={
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<Add />}
                        onClick={handleSave}
                    >
                        {editingRole ? "Änderungen speichern" : "Rolle anlegen"}
                    </Button>                }
            />

            {/* CONTENT */}
            <CardContent>
                <div className={classes.formRow}>
                    <TextField
                        label="Rollenname"
                        variant="outlined"
                        size="small"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        fullWidth
                        InputLabelProps={{ style: { color: "#94a3b8" } }}
                        InputProps={{
                            style: { color: "#e2e8f0", background: "#020617" },
                        }}
                    />
                    <TextField
                        label="Beschreibung (optional)"
                        variant="outlined"
                        size="small"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        fullWidth
                        InputLabelProps={{ style: { color: "#94a3b8" } }}
                        InputProps={{
                            style: { color: "#e2e8f0", background: "#020617" },
                        }}
                    />
                </div>

                {loading ? (
                    <div className={classes.loadingWrapper}>
                        <CircularProgress />
                    </div>
                ) : error ? (
                    <div className={classes.emptyState}>{error}</div>
                ) : roles.length === 0 ? (
                    <div className={classes.emptyState}>
                        Noch keine Rollen vorhanden. Lege die erste Rolle an.
                    </div>
                ) : (
                    <List>
                        {roles.map((r) => (
                            <React.Fragment key={r.id}>
                                <ListItem>
                                    <ListItemText
                                        primary={r.name}
                                        secondary={r.description || null}
                                        primaryTypographyProps={{
                                            style: { color: "#e5e7eb", fontWeight: 600 },
                                        }}
                                        secondaryTypographyProps={{
                                            style: { color: "#94a3b8" },
                                        }}
                                    />

                                    <div className={classes.actions}>
                                        <IconButton
                                            size="small"
                                            onClick={() => handleEdit(r)}
                                        >
                                            <Edit fontSize="small" />
                                        </IconButton>

                                        <IconButton
                                            size="small"
                                            onClick={() => handleDelete(r)}
                                        >
                                            <Delete fontSize="small" />
                                        </IconButton>
                                    </div>
                                </ListItem>
                                <Divider />
                            </React.Fragment>
                        ))}
                    </List>
                )}
            </CardContent>
        </Card>
    );
}
